/*
* Created on Nov 03, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import {useEffect, useState} from 'react';
import ModalComponent from "./common/ModalComonent/ModalComponent";
import {useTranslation} from "react-i18next";
import axios from "axios";
import {useRegion} from "../context/RegionContext";
import Cookies from "js-cookie";
import {useSearchParams} from "react-router-dom";
import {useCookiesSettings} from "../context/CookiesSettingContext";


const DetectRegionComponent = ({showSwitchWarning=false, switchTo}) => {
    const {cookieSettings} = useCookiesSettings();
    const [dialog, setDialog] = useState(false);
    const {t} = useTranslation()
    const {region, selectRegion, getCurrentDomainRegion} = useRegion();
    const [currentRegion, setCurrentRegion] = useState('GLOBAL');
    const [auto, setAuto] = useState(!showSwitchWarning);
    const show_region_warning_cookie = Cookies.get('region_warning');

    const [searchParams, setSearchParams] = useSearchParams();

    const doSwitch = () => {
        // doNotShowDialog();
        if (switchTo) {
            selectRegion(switchTo);
        }
        else {
            selectRegion(currentRegion);
        }
    }

    const doNotShowDialog = () => {
        if (!show_region_warning_cookie && cookieSettings.FC) {
            Cookies.set('region_warning', false, { expires: 1 })
        }
        setDialog(false);
    }

    useEffect(()=>{
        let isMounted = true;
        getCurrentDomainRegion();
        const region_warning_cookie = Cookies.get('region_warning');
        let updatedSearchParams = new URLSearchParams(searchParams.toString());
        const param = updatedSearchParams.get('region_warning');
        if (param) {
            updatedSearchParams.delete('region_warning');
            // setSearchParams(updatedSearchParams.toString());
        }

        if (region_warning_cookie !== "false") {
            if (param){
                doNotShowDialog();
            }
        }
        const cancelToken = axios.CancelToken.source();
        axios.get('/ajax/region', {cancelToken: cancelToken.token}).then(resp=>{
            if (resp?.data.result === 'CHINA') {
                if (isMounted) {
                    setCurrentRegion('CHINA');
                }
            }
        }).catch((err)=>{
            console.log(err);
            if (isMounted) {
                setCurrentRegion('GLOBAL');
            }
        });

        return () => {cancelToken.cancel('regioin request cancelled'); isMounted = false;}
    }, []);

    useEffect(()=> {
        setDialog(region !== currentRegion);
    }, [region, currentRegion]);

    useEffect(() => {
        if (showSwitchWarning) {
            setDialog(region !== switchTo);
            setAuto(false);
        }
    }, [showSwitchWarning, switchTo]);

    // useEffect(()=> {
    //     if (switchTo && show_region_warning_cookie) {
    //         doSwitch();
    //     }
    // }, [switchTo]);

    return (
        <>
            {(dialog && (!show_region_warning_cookie || showSwitchWarning) )  && <ModalComponent isOpen={dialog} onClose={doNotShowDialog} title={t('@Warning@')} okText={t('@OK@')} onSubmit={doSwitch} closeText={t('@Not remind me today@')} enableAlert={false}>
                <div className="dialog-content">
                    {!auto && <div className="text-wrap">{t('@Switching to the location may have poor network performance. Are you sure to continuous?@')}</div>}
                    {auto && <div className="text-wrap">{t('@You are not using the suitable domain with best network performance. Do you want to change to the suggestion domain?@')}</div>}
                    <div className="text-wrap">{t('@Note: You need to sign in website again after switched.@')}</div>
                </div>
            </ModalComponent>}
        </>
    );
};

export default DetectRegionComponent;